// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Logs Styles */

.admin-logs-container {
  padding: 20px;
  max-width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
}

.logs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logs-header h1 {
  margin: 0;
  font-size: 28px;
  color: #333;
}

.logs-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.auto-refresh-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.auto-refresh-toggle input[type="checkbox"] {
  cursor: pointer;
}

.refresh-btn,
.archive-btn,
.view-details-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.refresh-btn {
  background: #2196F3;
  color: white;
}

.refresh-btn:hover {
  background: #1976D2;
}

.refresh-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.archive-btn {
  background: #FF9800;
  color: white;
}

.archive-btn:hover {
  background: #F57C00;
}

.view-details-btn {
  background: #4CAF50;
  color: white;
  padding: 4px 12px;
  font-size: 12px;
}

.view-details-btn:hover {
  background: #45a049;
}

/* Statistics */
.logs-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  border-left: 4px solid #2196F3;
}

.stat-card.error {
  border-left-color: #F44336;
}

.stat-card.critical {
  border-left-color: #D50000;
}

.stat-card.warn {
  border-left-color: #FF9800;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #666;
  text-transform: uppercase;
}

/* Filters */
.logs-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.filter-group label {
  font-size: 14px;
  font-weight: 500;
  color: #555;
}

.filter-group select,
.filter-group input[type="datetime-local"] {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.checkbox-label input[type="checkbox"] {
  cursor: pointer;
}

/* Logs Table */
.logs-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.logs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.logs-table thead {
  background: #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 10;
}

.logs-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #ddd;
}

.logs-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
  vertical-align: top;
}

.logs-table tbody tr:hover {
  background: #f9f9f9;
}

.log-row.log-level-error {
  background: #ffebee;
}

.log-row.log-level-critical {
  background: #ffcdd2;
}

.log-row.log-level-warn {
  background: #fff3e0;
}

.log-time {
  white-space: nowrap;
  font-family: monospace;
  font-size: 12px;
  color: #666;
}

.log-level-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
  white-space: nowrap;
}

.log-type-badge {
  display: inline-block;
  padding: 4px 8px;
  background: #E3F2FD;
  color: #1976D2;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.log-message-cell {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
}

.log-endpoint {
  font-family: monospace;
  font-size: 12px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.endpoint-badge {
  display: flex;
  align-items: center;
  gap: 4px;
}

.http-method {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
  color: white;
}

.method-get { background: #4CAF50; }
.method-post { background: #2196F3; }
.method-put { background: #FF9800; }
.method-patch { background: #FFC107; }
.method-delete { background: #F44336; }

.log-user {
  font-family: monospace;
  font-size: 12px;
  color: #666;
}

.log-duration {
  font-family: monospace;
  font-size: 12px;
  color: #666;
  text-align: right;
}

.no-logs {
  text-align: center;
  padding: 40px;
  color: #999;
  font-style: italic;
}

.logs-loading {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

/* Log Details Modal */
.log-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.log-modal {
  background: white;
  border-radius: 8px;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.log-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 2px solid #eee;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.log-modal-header h2 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.log-modal-header button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.log-modal-header button:hover {
  background: #f5f5f5;
  color: #333;
}

.log-modal-body {
  padding: 20px;
}

.log-detail-section {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.log-detail-section:last-child {
  border-bottom: none;
}

.log-detail-section h3 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 16px;
  color: #555;
}

.log-detail-item {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: flex-start;
}

.log-detail-label {
  font-weight: 600;
  color: #555;
  min-width: 120px;
}

.log-user-id,
.log-endpoint {
  font-family: monospace;
  font-size: 13px;
  color: #333;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
}

.status-code {
  font-family: monospace;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 3px;
}

.status-2xx { background: #C8E6C9; color: #2E7D32; }
.status-3xx { background: #BBDEFB; color: #1565C0; }
.status-4xx { background: #FFE082; color: #F57F17; }
.status-5xx { background: #FFCDD2; color: #C62828; }

.log-message,
.log-metadata,
.log-error-stack {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
}

.log-error-stack {
  background: #FFEBEE;
  color: #C62828;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .logs-stats {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }
}

@media (max-width: 768px) {
  .logs-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .logs-actions {
    width: 100%;
    flex-direction: column;
  }

  .logs-filters {
    grid-template-columns: 1fr;
  }

  .logs-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .logs-table {
    font-size: 12px;
  }

  .logs-table th,
  .logs-table td {
    padding: 8px;
  }

  .log-modal {
    width: 95%;
    max-height: 95vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AdminLogs.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA,cAAc,mBAAmB,EAAE;AACnC,eAAe,mBAAmB,EAAE;AACpC,cAAc,mBAAmB,EAAE;AACnC,gBAAgB,mBAAmB,EAAE;AACrC,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,mBAAmB,EAAE,cAAc,EAAE;;AAEnD;;;EAGE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF","sourcesContent":["/* Admin Logs Styles */\n\n.admin-logs-container {\n  padding: 20px;\n  max-width: 100%;\n  background: #f5f5f5;\n  min-height: 100vh;\n}\n\n.logs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.logs-header h1 {\n  margin: 0;\n  font-size: 28px;\n  color: #333;\n}\n\n.logs-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.auto-refresh-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.auto-refresh-toggle input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.refresh-btn,\n.archive-btn,\n.view-details-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.refresh-btn {\n  background: #2196F3;\n  color: white;\n}\n\n.refresh-btn:hover {\n  background: #1976D2;\n}\n\n.refresh-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.archive-btn {\n  background: #FF9800;\n  color: white;\n}\n\n.archive-btn:hover {\n  background: #F57C00;\n}\n\n.view-details-btn {\n  background: #4CAF50;\n  color: white;\n  padding: 4px 12px;\n  font-size: 12px;\n}\n\n.view-details-btn:hover {\n  background: #45a049;\n}\n\n/* Statistics */\n.logs-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.stat-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  border-left: 4px solid #2196F3;\n}\n\n.stat-card.error {\n  border-left-color: #F44336;\n}\n\n.stat-card.critical {\n  border-left-color: #D50000;\n}\n\n.stat-card.warn {\n  border-left-color: #FF9800;\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #666;\n  text-transform: uppercase;\n}\n\n/* Filters */\n.logs-filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.filter-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #555;\n}\n\n.filter-group select,\n.filter-group input[type=\"datetime-local\"] {\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n/* Logs Table */\n.logs-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.logs-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.logs-table thead {\n  background: #f5f5f5;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.logs-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #ddd;\n}\n\n.logs-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #eee;\n  vertical-align: top;\n}\n\n.logs-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.log-row.log-level-error {\n  background: #ffebee;\n}\n\n.log-row.log-level-critical {\n  background: #ffcdd2;\n}\n\n.log-row.log-level-warn {\n  background: #fff3e0;\n}\n\n.log-time {\n  white-space: nowrap;\n  font-family: monospace;\n  font-size: 12px;\n  color: #666;\n}\n\n.log-level-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: bold;\n  color: white;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.log-type-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  background: #E3F2FD;\n  color: #1976D2;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.log-message-cell {\n  max-width: 400px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #333;\n}\n\n.log-endpoint {\n  font-family: monospace;\n  font-size: 12px;\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.endpoint-badge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.http-method {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: bold;\n  color: white;\n}\n\n.method-get { background: #4CAF50; }\n.method-post { background: #2196F3; }\n.method-put { background: #FF9800; }\n.method-patch { background: #FFC107; }\n.method-delete { background: #F44336; }\n\n.log-user {\n  font-family: monospace;\n  font-size: 12px;\n  color: #666;\n}\n\n.log-duration {\n  font-family: monospace;\n  font-size: 12px;\n  color: #666;\n  text-align: right;\n}\n\n.no-logs {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n  font-style: italic;\n}\n\n.logs-loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n/* Log Details Modal */\n.log-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.log-modal {\n  background: white;\n  border-radius: 8px;\n  max-width: 900px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.log-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 2px solid #eee;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10;\n}\n\n.log-modal-header h2 {\n  margin: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.log-modal-header button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #999;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.log-modal-header button:hover {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.log-modal-body {\n  padding: 20px;\n}\n\n.log-detail-section {\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.log-detail-section:last-child {\n  border-bottom: none;\n}\n\n.log-detail-section h3 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-size: 16px;\n  color: #555;\n}\n\n.log-detail-item {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n  align-items: flex-start;\n}\n\n.log-detail-label {\n  font-weight: 600;\n  color: #555;\n  min-width: 120px;\n}\n\n.log-user-id,\n.log-endpoint {\n  font-family: monospace;\n  font-size: 13px;\n  color: #333;\n  background: #f5f5f5;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.status-code {\n  font-family: monospace;\n  font-weight: bold;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.status-2xx { background: #C8E6C9; color: #2E7D32; }\n.status-3xx { background: #BBDEFB; color: #1565C0; }\n.status-4xx { background: #FFE082; color: #F57F17; }\n.status-5xx { background: #FFCDD2; color: #C62828; }\n\n.log-message,\n.log-metadata,\n.log-error-stack {\n  background: #f5f5f5;\n  padding: 15px;\n  border-radius: 4px;\n  overflow-x: auto;\n  font-family: monospace;\n  font-size: 13px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  margin: 0;\n}\n\n.log-error-stack {\n  background: #FFEBEE;\n  color: #C62828;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .logs-stats {\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .logs-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .logs-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .logs-filters {\n    grid-template-columns: 1fr;\n  }\n\n  .logs-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .logs-table {\n    font-size: 12px;\n  }\n\n  .logs-table th,\n  .logs-table td {\n    padding: 8px;\n  }\n\n  .log-modal {\n    width: 95%;\n    max-height: 95vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
